import { render, staticRenderFns } from "./TelaDeCadastroDeRegrasDeInadimplencia.vue?vue&type=template&id=1d624d5c&"
import script from "./TelaDeCadastroDeRegrasDeInadimplencia.vue?vue&type=script&lang=ts&"
export * from "./TelaDeCadastroDeRegrasDeInadimplencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VContainer,VIcon,VTextField})
